import { useInitFirebase } from "./init-firebase";

const FirebaseWrapper = () => {
  useInitFirebase();
  return <div className="hidden"></div>;
};

export default FirebaseWrapper;
